import { useEffect } from 'react';
import { SEARCH_TAB } from '../constants/resourceTabs';
import { useShownResources } from '../ResourceStore';

export const useFilterResourcesByTab = (resources, activeTab) => {
  const setShownResources = useShownResources.getState().setShownResources;

  useEffect(() => {
    if (SEARCH_TAB.value === activeTab) {
      return;
    }

    const tabFiltered = resources.filter(resource => resource.tabName === activeTab);
    setShownResources(tabFiltered);
  }, [resources, activeTab, setShownResources]);
};
